import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=390dcef9&scoped=true&"
var script = {}
import style0 from "./Message.vue?vue&type=style&index=0&id=390dcef9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390dcef9",
  null
  
)

export default component.exports